// extracted by mini-css-extract-plugin
export default {"icon":"IconClickHandler_icon__RUvLN"};